import { Link } from 'react-router-dom';
import { hotList } from '@/mocks/hotList';
import SectionHeading from '@/components/feature/SectionHeading';
import ArticleCard from '@/components/feature/ArticleCard';
import TrendBadge from '@/components/feature/TrendBadge';

export default function HotSpotSection() {
  const featured = hotList[0];
  const sides = hotList.slice(1, 3);

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="TODAY'S SPOTLIGHT"
        title="今日爆点，先看这三条"
        description="综合讨论量、传播速度和互动密度，我们把今天声量最高的三条放在最前面，帮你省掉筛选的时间。"
        actionLabel="全部速报"
        actionTo="/ranking"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <ArticleCard item={featured} size="large" />

        <div className="flex flex-col gap-5">
          {sides.map((item) => (
            <article
              key={item.id}
              className="group flex flex-1 items-stretch overflow-hidden rounded-card border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <Link to={`/article/${item.id}`} className="flex w-full flex-col sm:flex-row">
                <div className="relative h-40 w-full shrink-0 overflow-hidden sm:h-auto sm:w-44">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 瓜圈速报`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <div className="flex items-center gap-2">
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                      {item.category}
                    </span>
                    <span className="text-[11px] text-foreground-400">{item.publishedAt}</span>
                  </div>
                  <h3 className="mt-2 text-balance text-[15px] font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-fire-line text-primary-500" />
                      {item.heat}
                    </span>
                    <TrendBadge trend={item.trend} value={item.trendValue} compact />
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}